import { render, staticRenderFns } from "./SendTime.vue?vue&type=template&id=39d635d6"
import script from "./SendTime.vue?vue&type=script&lang=js"
export * from "./SendTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports